import { ColDef } from 'ag-grid-community';
import {
  createAdministratorNameCol,
  createDateCol,
  createDetailButtonColV2,
  createIdCol,
  createTypoCol,
  createViewableCol,
} from '@/src/helpers/agColumnHelper';

export const faqListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateCol({
    field: 'createdAt',
    width: 131,
    minWidth: 131,
    maxWidth: 231,
    headerName: '등록 일시',
  }),
  createTypoCol({
    field: 'faqCategoryType',
    width: 200,
    minWidth: 200,
    maxWidth: 300,
    headerName: '카테고리',
  }),
  createTypoCol({
    field: 'title',
    width: 317,
    minWidth: 500,
    headerName: '제목',
  }),
  createViewableCol({
    field: 'showedYn',
    size: 'sm',
    headerName: '노출 여부',
  }),
  createAdministratorNameCol({
    headerName: '등록 관리자',
    size: 'sm',
  }),
  createDetailButtonColV2(onDetailClick),
];
